"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.separateByCapitals = void 0;
function separateByCapitals(text) {
    const regex = /([A-Z])/g;
    const result = text.replace(regex, " $1");
    return result.trim();
}
exports.separateByCapitals = separateByCapitals;
